import React from 'react';
import { injectIntl } from 'react-intl';

import CreateAccountContainer from '../../apollo/containers/CreateAccountContainer';


export default injectIntl(
  ({ intl }) => {
    const errorMessages = {
      nameNotValid: intl.formatMessage({ id: 'login.error.nameNotValid' }),
      emailNotValid: intl.formatMessage({ id: 'login.error.emailNotValid' }),
      passwordNotValid: intl.formatMessage({ id: 'login.error.passwordNotValid' }),
      passwordsNotEqual: intl.formatMessage({ id: 'login.error.passwordsNotEqual' }),
    };

    return (
      <div>
        <h1 className="ui inverted header">{intl.formatMessage({ id: 'login.signIn' })}</h1>
        <CreateAccountContainer
          title={intl.formatMessage({ id: 'login.title.create' })}
          nameLabel={intl.formatMessage({ id: 'login.label.name' })}
          passwordLabel={intl.formatMessage({ id: 'login.label.password' })}
          confirmPasswordLabel={intl.formatMessage({ id: 'login.label.confirmation' })}
          backLabel={intl.formatMessage({ id: 'login.back' })}
          message={intl.formatMessage({ id: 'login.success.created' })}
          callToAction={intl.formatMessage({ id: 'login.continue' })}
          errorTitle={intl.formatMessage({ id: 'login.error' })}
          errorMessages={errorMessages}
          backLink="/"
        />
      </div>
    )
  }
);



/** WEBPACK FOOTER **
 ** ./src/app/modules/login/pages/new/index.js
 **/